import { Stamp } from 'models';

export interface S9ApiStamp {
  ID: number;
  Text: string;
}

/**
 * Creates a stamp from the API model.
 *
 * @param apiStamp API stamp.
 * @returns A stamp.
 */
export const createStampFromApi = (apiStamp: S9ApiStamp): Stamp => ({
  id: apiStamp.ID,
  text: apiStamp.Text,
});
